import { useQuery } from "@apollo/react-hooks";

import { Instructor } from "@hubcapp/graphql";
import todaysEventsQuery from "@hubcapp/graphql/todaysEvents.graphql";

import { format } from "date-fns";
import { getNextLesson } from "./helpers";

type TodaysEventsQueryResponse = {
  me: Instructor;
};

const useTodaysLessons = () => {
  const { loading, data, error } = useQuery<TodaysEventsQueryResponse>(
    todaysEventsQuery,
  );

  if (error) {
    throw error;
  }

  const lessons = data?.me.todaysEvents;

  const numberOfLessons = lessons && lessons.length;
  const nextLesson = lessons && getNextLesson(lessons);
  const nextLessonTime =
    nextLesson && format(new Date(nextLesson.startDateTime), "h:mma");

  return { loading, numberOfLessons, nextLessonTime, nextLesson };
};

export default useTodaysLessons;
